import styled from 'styled-components';
import { propStyles } from '../../../utils/propStyles';
import { top, whiteSpace } from '../../../utils/customPropStyles';

const StyledComponent = styled<any, any>('div')`
    ${propStyles};
    ${top};
    ${whiteSpace};
`;

StyledComponent.defaultProps = {
    position: 'absolute',
    top: 'calc(100% + 1px)',
    zIndex: 'dropdown',
    width: ['100%', '80%'],
    margin: ['0', '0 10%'],
    bgColor: 'white',
    borderWidth: '1px',
    borderColor: 'gray300',
    borderStyle: 'solid',
    borderRadius: 'sm',
    boxShadow: 'sm',
};

export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Dropdown/StyledComponents/DropdownMenu.tsx